module.exports = __webpack_public_path__ + "img/home2.4358da8b.jpg";